module.exports = __webpack_public_path__ + "img/logo_Gnp.a374a5a4.svg";